import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { supportsCookies } from "../../../utils";

/**
 * Does the current browser support cookies?
 */
var preDecisionGatewaySupportsCookies = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", supportsCookies() ? false : "essentials");

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewaySupportsCookies() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewaySupportsCookies };